import { useState } from "react";
import { CheckCircleOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";
import { BbotButton, BbotTag, SettingsCard } from "top-component-library";
import { SettingControlRow } from "../styles";
import SelfDeliveryDialog from "../SelfDeliveryDialog";

const SelfDeliveryCard = ({ enabled, maxDeliveryMiles, allowedZipCodes, onSave }) => {
  const [dialogVisible, setDialogVisible] = useState(false);

  return (
    <SettingsCard title="Delivery Zone">
      <p>
        Enabling this feature will allow you to reject orders to delivery addresses that are too far away or outside of
        specific zip codes. This setting is important <strong>if using your own drivers</strong>. It is usually NOT
        necessary if you are already using a delivery service (i.e., DoorDash) because most delivery services already
        set a delivery zone.{" "}
        <a
          href="https://dd1psupport.zendesk.com/hc/en-us/articles/32479387913236-Delivery-Zone-Settings-Widget"
          target="_blank"
          rel="noreferrer"
        >
          More info.
        </a>
      </p>
      {enabled && (
        <>
          {maxDeliveryMiles ? (
            <p>
              The maximum distance you will accept orders from (in miles): <strong>{maxDeliveryMiles}</strong>
            </p>
          ) : null}
          <p>
            {allowedZipCodes.length > 0
              ? `Your list of allowed zip codes (for reference): ${allowedZipCodes.join(", ")}`
              : "You're currently allowing all zip codes within your radius."}
          </p>
        </>
      )}
      {enabled ? (
        <SettingControlRow>
          <BbotTag color="success">
            Enabled <CheckCircleOutlined />
          </BbotTag>
          <BbotButton type="link" onClick={() => setDialogVisible(true)}>
            Change Settings
          </BbotButton>
        </SettingControlRow>
      ) : (
        <SettingControlRow>
          <BbotButton type="primary" onClick={() => setDialogVisible(true)}>
            Enable
          </BbotButton>
        </SettingControlRow>
      )}
      <SelfDeliveryDialog
        visible={dialogVisible}
        enabled={enabled}
        maxDeliveryMiles={maxDeliveryMiles}
        allowedZipCodes={allowedZipCodes}
        onClose={() => setDialogVisible(false)}
        onSave={onSave}
      />
    </SettingsCard>
  );
};

SelfDeliveryCard.propTypes = {
  enabled: PropTypes.bool.isRequired,
  maxDeliveryMiles: PropTypes.number,
  allowedZipCodes: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSave: PropTypes.func.isRequired,
};

SelfDeliveryCard.defaultProps = {
  maxDeliveryMiles: null,
};

export default SelfDeliveryCard;
